// extracted by mini-css-extract-plugin
export default {"headline":"NotFound_headline__bXJ0g","textUnderH":"NotFound_textUnderH__UWy1s","imageTr":"NotFound_imageTr__-C014"};